module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-about.jpg',
      "title": _vm.$t('pages.about.title'),
      "subtitle": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.about.content'))
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed53b04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AboutView.vue
// module id = 506
// module chunks = 1